import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';

const FollowNarrative = loadable(() => import('./FollowNarrative'));

const FlaggedFollowNarrative = () => {
  const { flagsReady, enabled } = useFlag({
    name: 'mono-narrative-follow',
  });

  if (!flagsReady || !enabled) {
    return null;
  }

  return <FollowNarrative />;
};

export default FlaggedFollowNarrative;
